import React from 'react';

const chipStyle = (color, bg, border) => ({
    display: 'inline-flex', alignItems: 'center', fontSize: 11, fontWeight: 600, lineHeight: 1,
    borderRadius: 6, padding: '3px 7px', color, backgroundColor: bg, border: `1px solid ${border}`, whiteSpace: 'nowrap',
});

/**
 * What the image picker shows about an Azure image besides its name: the
 * architecture, the Hyper-V generation (which decides what can boot it), and
 * where it lives. A gallery version is worth calling out because it is the
 * only place an Arm64 image can exist - managed images are x64 only.
 */
export default function AzureImageChips({ image }) {
    if (!image) return null;
    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
            {image.arch && <span style={chipStyle('#475569', '#eef2f7', '#e2e8f0')}>{image.arch === 'x86_64' ? 'x86' : image.arch}</span>}
            {image.hyperVGeneration && (
                <span style={chipStyle('#475569', '#eef2f7', '#e2e8f0')} title="Hyper-V generation: a VM size has to support this to boot the image">
                    {image.hyperVGeneration}
                </span>
            )}
            {image.source === 'gallery' && (
                <span style={chipStyle('#3730a3', '#eef2ff', '#c7d2fe')} title="Published to the Heidi compute gallery. Arm64 images can only live here.">
                    gallery {image.version}
                </span>
            )}
            {image.source === 'managed' && image.resourceGroup && (
                <span style={{ fontSize: 12, color: '#64748b', whiteSpace: 'nowrap' }} title="The resource group this managed image lives in">
                    {image.resourceGroup}
                </span>
            )}
        </span>
    );
}
